export function packagesRevenue(state = [], action) {
  switch (action.type) {
    case "PACKAGE_REVENUE_ANALYTICS_SUCCESS":
      return action.data;
    default:
      return state;
  }
}
